// =============================================================================
// Find Your...
// =============================================================================

$('document').ready(() => {

    const showHideFilter = type => {
        return event => {
            event.preventDefault();

            $(event.target).toggleClass('clicked');
            $(event.target).find('ul').slideToggle("fast");
        };
    };

    $('.club-filter span').on('click', showHideFilter());

    const filterclub = type => {
        return event => {
            event.preventDefault();

            $('.club-filter span ul').slideToggle("fast");
            $('.club-filter span').toggleClass('clicked');
            var id = $(event.target).attr('id');
            if (id === 'all'){
                $('.club-list--secondary li').show('fast');
                $('.club-filter span strong').html('All');
            } else {
                $('.club-list--secondary li').each(function(){
                    if (!$(this).hasClass(id)){
                        $(this).hide('fast');
                    } else {
                        $(this).show('fast');
                    }
                });
                $('.club-filter span strong').html($(event.target).html());
            }
        };
    };

    $('.club-filter span li').on('click', filterclub());

    function initiateTicker(){

        var width = $('.club-list--footer').width();
        while ($('.club-list--footer li').length < 30) {
            $('.club-list--footer li').each(function(i){
                if (i > 15)
                    return;

                $('.club-list--footer').append('<li class="club-list__item">'+$(this).html()+'</li>');
            })
        }
        var ms = width / 0.2;
        $('.club-list--footer').css('transition', ms/1000 + 's transform linear');
        var runticker = setInterval(function() {
            $('.club-list--footer').css('transform', 'translateX(-'+ width + 'px)');
        }, ms);

    }

    // initiateTicker();
});



// WEBPACK FOOTER //
// ./public/themes/masuri/assets/js/library/ClubFilter.js